import React from "react";
import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Subject, List } from "@mui/icons-material";
import { getQuestionTypeIcon } from "../utils";

export const AvailableQuestionTypes = {
  LongText: {
    displayName: "Long Text",
    backendName: "LONG",
    icon: Subject,
    usedInQuizzes: false,
    usedInAssignments: true,
  },
  MultipleChoice: {
    displayName: "Multiple Choice",
    backendName: "MCQ",
    icon: List,
    usedInQuizzes: true,
    usedInAssignments: false,
  },
  TrueFalse: {
    displayName: "True or False",
    backendName: "TRUE_OR_FALSE",
    icon: "Boolean",
    usedInQuizzes: true,
    usedInAssignments: false,
  },
};

export const QuestionTypePicker = ({
  selectedQuestionType,
  setSelectedQuestionType,
  stackProps = {},
  quiz = false,
}) => {
  const handleChange = (event, newType) => {
    if (newType !== null) {
      setSelectedQuestionType(newType);
    }
  };

  return (
    <Stack
      direction="row"
      alignItems={"center"}
      width={"100%"}
      sx={{ mt: 2, mb: 2 }}
      {...stackProps}
    >
      <ToggleButtonGroup
        value={selectedQuestionType}
        exclusive
        onChange={handleChange}
        aria-label="Question type selector"
      >
        {Object.entries(AvailableQuestionTypes)
          .filter(([, { usedInQuizzes }]) => !quiz || usedInQuizzes)
          .map(([typeKey, { backendName, displayName, icon: Icon }]) => (
            <ToggleButton key={typeKey} value={backendName} aria-label={name}>
              {displayName} {getQuestionTypeIcon(Icon)}{" "}
            </ToggleButton>
          ))}
      </ToggleButtonGroup>
    </Stack>
  );
};
